import { Link } from 'react-router-dom';
import { Volleyball } from 'lucide-react';
import { cn } from '@/lib/utils';
import config from '@/config';

function Footer({ variant = 'public', className }) {
  const year = new Date().getFullYear();

  if (variant === 'admin') {
    return (
      <footer className={cn('border-t border-border bg-card px-6 py-4', className)}>
        <p className="text-center text-sm text-muted-foreground">
          &copy; {year} {config.appName}. All rights reserved.
        </p>
      </footer>
    );
  }

  return (
    <footer className={cn('bg-primary-900 text-white', className)}>
      <div className="vp-container py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <Volleyball className="h-6 w-6 text-accent-cyan" />
              <span className="font-display text-xl font-bold">{config.appName}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-white/60">
              Premium shooting volleyball tournament management. Where every point matters.
            </p>
          </div>
          <div>
            <h4 className="font-display font-semibold">Platform</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/60">
              <li><Link to="/" className="hover:text-white transition-colors">Tournaments</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors">Live Scores</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors">Teams</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-semibold">Legal</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/60">
              <li><Link to="/" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-white/10 pt-6 text-center text-sm text-white/40">
          &copy; {year} {config.appName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
